// Types
import { UploadIdApiResponseType } from 'containers/upload-id/types/upload-id-api-response.type';

const urlFromVERIDASGeneratedIsCorrect = (response: UploadIdApiResponseType): boolean =>
  Boolean(response?.validationId && response?.url);

export { urlFromVERIDASGeneratedIsCorrect };
